import React, { useEffect } from 'react';
export const EmptyResults = ({ onNotFound, searchTerm, notFoundComponent, }) => {
    useEffect(() => {
        onNotFound?.(searchTerm);
    }, []);
    if (notFoundComponent) {
        return React.createElement("li", null, notFoundComponent);
    }
    return React.createElement("li", null, "No results");
};
//# sourceMappingURL=EmptyResults.js.map